import { baseServiceRequest } from "@apis/baseServiceRequest"
import type { ISalesLocation } from "./types"

export const getSalesLocations = async (
  params: { active?: boolean } = {},
): Promise<ISalesLocation[]> => {
  const queryParams = new URLSearchParams()
  if (params.active !== undefined) {
    queryParams.append("active", String(params.active))
  }

  const response = await baseServiceRequest({
    method: "GET",
    url: `/offers/locations/sales_locations/?${queryParams.toString()}`,
  })
  return response.data
}
